<template>
  <footer>
    <div class="container">
      <div class="footmenu">
        <div class="footerlogo">
          <a href="#">
            <b-img class="foot-logo" alt="footer-logo" src="/shop/images/rmcoco_new.webp"></b-img>
          </a>
          <a href="#">
            <b-img class="callus" alt="call" src="/shop/images/phone.svg"></b-img>1-800-325-8025
          </a>
          <a href="mailto:customerservice@rmcoco.com">
            <b-img class="mailus" alt="mail" src="/shop/images/mail.svg"></b-img>customerservice@rmcoco.com
          </a>
        </div>
        <div class="foot_company">
          <h5>Company</h5>
          <ul>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/team">Team</a>
            </li>
            <li>
              <a href="/showrooms">Showrooms</a>
            </li>
            <li>
              <a href="/shop/contact">Contact</a>
            </li>
            <li>
              <a href="/career">Career</a>
            </li>
          </ul>
        </div>
        <div class="foot_services">
          <h5>Customer Services</h5>
          <ul>
            <li>
              <a href="/shop/account">Your Account</a>
            </li>
            <li>
              <a v-if="user.id" href="/customer-resources/">Customer Resources</a>
              <a v-else href="/shop/login">Customer Resources</a>
            </li>
          </ul>
        </div>
        <div class="foot_legal">
          <h5>Legal</h5>
          <ul>
            <li>
              <a href="/terms-of-services/">Terms of Service</a>
            </li>
            <li>
              <a href="/privacy-policy/">Privacy Policy</a>
            </li>
          </ul>
        </div>
        <div class="foot_social">
          <h5>Connect with us</h5>
          <ul class="footer_social">
            <li>
              <a href="https://www.facebook.com/RMCOCODecorLtd/" target="_blank">
                <b-img class="social_icon" alt="facebook" src="/shop/images/facebook.svg"></b-img>
              </a>
            </li>
            <li>
              <a class="color_icn" href="https://www.youtube.com/channel/UCB_pcf-Eonyw4stwxHH4Adg" target="_blank">
                <b-img class="social_icon" alt="youtube" src="/shop/images/youtube.svg"></b-img>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/rm_coco/" target="_blank">
                <b-img class="social_icon" alt="instagram" src="/shop/images/instagram.svg"></b-img>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/bhw103120" target="_blank">
                <b-img class="social_icon" alt="twitter" src="/shop/images/twitter.svg"></b-img>
              </a>
            </li>
            <li>
              <a href="https://www.pinterest.com/RMCOCODECOR/_created/" target="_blank">
                <b-img class="social_icon" alt="pinterest" src="/shop/images/pinterest.svg"></b-img>
              </a>
            </li>
            <li>
              <a href="https://www.houzz.com/" target="_blank">
                <b-img class="social_icon" alt="houzz" src="/shop/images/houzz.svg"></b-img>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="copyrightdiv">
        <div class="copyright_sec">
          <p class="copyright_text">&copy; 1980 - {{ new Date().getFullYear() }} RM COCO</p>
          <ul>
            <li>
              <b-img class="payment_method" alt="mastercard" src="/shop/images/mastercard.svg"></b-img>
            </li>
            <li>
              <b-img class="payment_method" alt="discover" src="/shop/images/discover.svg"></b-img>
            </li>
            <li>
              <b-img
                class="payment_method"
                alt="american express"
                src="/shop/images/american-express.svg"
              ></b-img>
            </li>
            <li>
              <b-img class="payment_method" alt="visa" src="/shop/images/visa.svg"></b-img>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import ResourceMixin from "../mixins/resources";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user"])
  }
};
</script>
<style>
footer {
  padding-top: 80px;
  box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 4;
  background: #fff;
}
footer .footmenu {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding-bottom: 45px;
}
footer .footmenu .footerlogo {
  max-width: 250px;
}
footer .footmenu .footerlogo a img.foot-logo {
  height: 42px;
  width: 135px;
  margin-bottom: 18px;
}
footer .footmenu .footerlogo a,
footer .footmenu a {
  display: inline-block;
  width: 100%;
  color: #202020;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  text-decoration: none;
}
footer .footmenu #custom_html-4 a:hover,footer .footmenu #custom_html-5 a:hover,
footer .footmenu #custom_html-6 a:hover,footer .footmenu #custom_html-7 a:hover{
  text-shadow: 0px 0px 1px #303030;
}
footer .footmenu a:hover {
  text-decoration: none;
}
footer .footmenu a:hover{
    text-shadow: 0px 0px 1px #303030;
}
footer .footmenu .footerlogo a:hover{
	text-shadow:none;
}
footer .footmenu .footerlogo a {
  display: flex;
}
footer .footmenu .footerlogo a img.callus,
footer .footmenu .footerlogo a img.mailus {
  height: 14px;
  width: 16px;
  display: inline-block;
  margin-right: 6px;
  position: relative;
  top: 3px;
}
footer .footmenu a {
  color: #303030;
}
footer .footmenu h5 {
  color: #303030;
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 15px 0;
  padding: 0;
  text-align: left;
}
footer .footmenu ul.footer_social {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}
footer .footmenu ul.footer_social li {
  margin-right: 20px;
}
footer .footmenu ul.footer_social li:last-child {
  margin-right: 0;
}
footer .footmenu ul.footer_social li a{
  opacity: 1;
}
footer .footmenu ul.footer_social li a:hover{
  opacity: 0.8;
}
footer .footmenu ul.footer_social li a img.social_icon {
  max-width: 23px;
  width: 23px;
}
footer .copyrightdiv .copyright_sec {
  display: flex;
  justify-content: space-between;
  height: 90px;
  align-items: center;
  border-top: 1px solid #d2d2d2;
}
footer .copyrightdiv .copyright_sec p.copyright_text {
  font-weight: 500;
  font-size: 14px;
  color: #202020;
}
footer .copyrightdiv .copyright_sec ul {
  display: flex;
  align-items: center;
}
footer .copyrightdiv .copyright_sec ul li {
  list-style: none;
  float: left;
  margin-right: 4.5rem;
}
footer .copyrightdiv .copyright_sec ul li:last-child {
  margin-right: 0;
}
footer .copyrightdiv .copyright_sec ul li img {
  max-width: 50px;
  width: 50px;
}
@media only screen and (max-width:1024px) and (min-width:768px){
	footer{
		padding-top:50px;
	}
}
@media only screen and (max-width:767px){
	footer{
		padding-top:40px;
	}
	footer .footmenu{
		flex-wrap:wrap;
	}
	footer .footmenu .footerlogo{
		max-width: 100%;
		width: 100%;
	}
	footer .footmenu .foot_company,footer .footmenu .foot_services{
		margin-bottom: 30px;
		width: 50%;
		margin-top:30px;
	}
	footer .footmenu .foot_legal {
		width: 100%;
		margin-bottom:30px;
	}
	footer .copyrightdiv .copyright_sec{
		flex-wrap:wrap;
		justify-content:center;
	}
}
</style>